import styles from "./SentryFallbackPage.module.scss";

export const SentryFallbackPage = () => (
  <div className={styles.sentryFallbackPage}>An error has occurred</div>
);
